
const fileToDataUri = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    try {
        reader.onload = (event) => {
            resolve(event.target.result);
        }
        reader.readAsDataURL(file);
    } catch (e) {
        console.log(e);
        reject(null);
    }
});

const fileUpload = (params, isUploading = true) => {
    const fileData = params.data.split(';');
    const fileName = params.name.split('.');
    const mimeType = fileData[0].replace("data:", "");
    const base64 = fileData[1].replace("base64,", "");
    const ext = fileName.pop();
    
    return {
        id: Math.random() * 1000,
        base64,
        mimeType,
        name: params.name,
        ext:ext.toLowerCase(),
        isUploading,
        uploadProgress:0
    }
}

export const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

export { fileToDataUri, fileUpload};